import { createFileRoute } from '@tanstack/react-router';

import { JournalBrowse } from '@/module/Journal';

export const Route = createFileRoute('/_auth/journal/_journal/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <JournalBrowse />;
}
